
        <div class="loader-container" [hidden]="hidden">
            <div class="loader">
                <div class="loader__figure"></div>
                <p class="loader__label">Please wait</p>
            </div>
        </div>
    